export default function Home() {
  window.location.href = "https://zoooz.co/";

  return <></>;
}
